module.exports = __webpack_public_path__ + "d76c7f28e5343985051304c3be461602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-3.jpg
// module id = 1171
// module chunks = 0